var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "container"
  }, [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('a-row', {
    staticClass: "mb-15",
    attrs: {
      "gutter": [16, 16]
    }
  }, [_c('a-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm._trs('Day ahead market')))]), _c('a', {
    attrs: {
      "href": _vm.lang == 'en' ? 'https://belen-spot.me/day-ahead' : 'https://belen-spot.me/dan-unaprijed',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._trs('More details')))])]), _c('div', [_c('span', [_vm._v(_vm._s(_vm._trs('Delivery date')) + ": ")]), _c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.moment(_vm.delivery_day).format('DD.MM.YYYY')))])])])]), _c('a-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "text-bold mb-15 block-title"
  }, [_vm._v(" " + _vm._s(_vm._trs('Auction status')) + " ")]), _c('div', {
    staticClass: "block-wrapper"
  }, [_c('table', {
    staticClass: "status-table"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm._trs('Market status')))]), _c('th', [_vm._v(_vm._s(_vm._trs('Order Book Closure CET')))]), _c('th', [_vm._v(_vm._s(_vm._trs('Market Result Publication')))]), _c('th', [_vm._v(_vm._s(_vm._trs('Comments')))])]), _vm.status ? _c('tr', {
    staticClass: "hoverable"
  }, [_c('td', [_vm._v(_vm._s(_vm.status.market_status))]), _c('td', [_vm._v(_vm._s(_vm.status.order_block_closure))]), _c('td', [_vm._v(_vm._s(_vm.status.order_block_closure))]), _c('td', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.status.comments))])]) : _c('tr', {
    staticClass: "hoverable"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Data is not available yet for delivery date')) + ": " + _vm._s(_vm.moment(_vm.delivery_day).format('DD.MM.YYYY')) + " ")])]), _vm.status && _vm.status.market_message ? _c('tr', [_c('div', [_vm._v(_vm._s(_vm._trs('Market message')))]), _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.status.market_message) + " ")])]) : _vm._e()])])])], 1), _c('a-row', {
    attrs: {
      "gutter": [16, 16]
    }
  }, [_c('a-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('div', {
    attrs: {
      "id": "day-ahead-result-price-chart"
    }
  }), _c('div', {
    staticClass: "stats"
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._trs('Base price')))]), _c('span', [_vm._v(" " + _vm._s(_vm.baseLoadBlock ? _vm.numberFormat(_vm.baseLoadBlock.block_price) : '-') + " €/MWh ")])]), _c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._trs('Peak price')))]), _c('span', [_vm._v(" " + _vm._s(_vm.peakLoadBlock ? _vm.numberFormat(_vm.peakLoadBlock.block_price) : '-') + " €/MWh ")])])])]), _c('a-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "mb-10",
    attrs: {
      "id": "day-ahead-result-qty-chart"
    }
  }), _c('div', {
    staticClass: "stats"
  }, [_c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._trs('Daily volume')))]), _c('span', [_vm._v(" " + _vm._s(_vm.numberFormat(_vm.dailyVolume)) + " MWh ")])]), _c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._trs('Monthly volume')))]), _c('span', [_vm._v(" " + _vm._s(_vm.numberFormat(_vm.monthlyVolume)) + " MWh ")])])])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }